export const SUBMITTED = 'submitted';
export const ACTIVE = 'active';
export const INACTIVE = 'nonactive';

export const MODERATOR_ID = 'f84c564a-b1ef-44c4-9701-9cffaa65bafd';
export const SUPER_ADMIN_ID = '5c3bb225-025d-4773-b11e-d9e12a18c8b2';
export const PRODAVAC_ID = 'e5f74f77-015c-49fd-a05a-bd7200aefe91';
